<h2>Customers</h2>
<div class="buttons">
  <button mat-raised-button (click)="addCustomer()" color="primary">New customer</button>
</div>
<mat-form-field class="full">
  <mat-label>Filter</mat-label>
  <input matInput (keyup)="filter(input.value)" #input>
</mat-form-field>
<div class="mat-elevation-z8">
    <table mat-table [dataSource]="customersService" matSort (matSortChange)="onSort($event)" >

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
      <td mat-cell *matCellDef="let row"> {{row.name}} </td>
    </ng-container>

    <ng-container matColumnDef="countOfClients">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Count Of Clients</th>
      <td mat-cell *matCellDef="let row"> {{row.countOfClients}} </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef class="action"></th>
      <td mat-cell *matCellDef="let row" class="action">
        <button mat-icon-button color="warn" (click)="removeCustomer($event, row)">
          <mat-icon>close</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="showClients(row.id)"></tr>

  </table>

  @if (customersPaginated()) {
    <mat-paginator
      [length]="customersPaginated().totalCount"
      [pageSize]="customersService.pageSize"
      [pageIndex]="customersService.page - 1"
      [pageSizeOptions]="[5, 10, 25, 100]"
      (page)="onPage($event)"
    >
    </mat-paginator>
  }
</div>
